import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeStep: 0,
  stepsPassed: 0,
  stepStructure: [],
  appointmentData: {},
  scriptMessages: [],
  cancelStepActive: false,
  successStepActive: false,
  stepMainIdIndicator: undefined,
  stepCustomerDetailsDisabled: false,
};

const activeStepSlice = createSlice({
  name: 'activeStep',
  initialState,
  reducers: {
    nextStepSet(state, _) { state.activeStep++ },
    backStepSet(state, _) { state.activeStep-- },
    activeStepSet(state, { payload }) { state.activeStep = payload },
    stepsPassedSet(state, { payload }) { state.stepsPassed = payload },
    stepStructureSet(state, { payload }) { state.stepStructure = payload },
    cancelStepSet(state, { payload }) { state.cancelStepActive = payload },
    successStepSet(state, { payload }) { state.successStepActive = payload },
    appointmentDataSet(state, { payload }) { state.appointmentData = payload },
    scriptMessagesSet(state, { payload }) { state.scriptMessages = payload },
    stepMainIdIndicatorSet(state, { payload }) { state.stepMainIdIndicator = payload },
    stepCustomerDetailsDisabledSet(state, { payload }) { state.stepCustomerDetailsDisabled = payload },

    resetStepsDataSet() { return initialState }
  }
});

export const {
  nextStepSet,
  backStepSet,
  activeStepSet,
  cancelStepSet,
  stepsPassedSet,
  successStepSet,
  stepStructureSet,
  resetStepsDataSet,
  appointmentDataSet,
  scriptMessagesSet,
  stepMainIdIndicatorSet,
  stepCustomerDetailsDisabledSet,

} = activeStepSlice.actions;

export default activeStepSlice.reducer;

